export default __webpack_public_path__ + "static/media/bulk_add_icon.eda748ca.svg";